import { apiFormDefaults } from '~constants/api';

import { get, post } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'company-form-defaults';

const config = [
  { actionType: 'getAll', apiPath: apiFormDefaults, method: get },
  { actionType: 'upsert', apiPath: apiFormDefaults, method: post },
  { actionType: 'getOne', apiPath: (params: Params) => `${apiFormDefaults}/${params.id}`, method: get },
];

export const { getAll, upsert, getOne } = createThunks(typePrefix, config);
